import { Pipe, PipeTransform } from '@angular/core';
import { VideoPodcastCategoryInnerModel } from 'src/app/models/video-podcast-category/video-podcast-category-inner';

@Pipe({
    name: 'categoryNames',
})
export class CategoryNamesPipe implements PipeTransform {

    transform(categories: VideoPodcastCategoryInnerModel[] | undefined): string {
        if (!categories || categories.length === 0) {
            return '';
        }

        return categories.map(cat => cat.titleEn).join(', ');
    }

}
